// extracted by mini-css-extract-plugin
export var fadeInOut = "_4b-3";
export var icon = "_4b-4";
export var savedIndicator = "_4b-2";
export var savingIndicator = "_4b-0";
export var spin = "_4b-1";